<template>
  <v-app>
    <v-toolbar app clipped-left color="#0b2b49" dark>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <v-toolbar-title class="text-center">
        <router-link to="/" tag="span" style="cursor: pointer">Aegeo Phone Booth</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat v-for="item in menuItems" :key="item.title" router :to="item.link">
          <v-icon left>{{ item.icon }}</v-icon>
          {{item.title}}
        </v-btn>
        <v-btn flat v-if="userisAuthenticated" @click="onLogout">
          <v-icon left>exit_to_app</v-icon>Logout
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer temporary clipped fixed v-model="drawer" app width="200px">
      <v-list>
        <v-list-tile @click v-for="item in menuItems" :key="item.title" router :to="item.link">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{item.title}}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click v-if="userisAuthenticated">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Logout</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <!-- in order to show below the toolbar, it has to be wrapped inside a v-content  -->
    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer height="auto" color="#0b2b49" dark>
      <v-layout justify-center row wrap>
        <v-flex color="#0b2b49" dark py-3 text-xs-center white--text xs12>
          &copy;2019 —
          <strong>Aegeo Spas</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: false
    };
  },
  computed: {
    menuItems() {
      let menuItems = [
        // { icon: "face", title: "Sign up", link: "/Signup" },
        { icon: "lock_open", title: "Sign In", link: "/Signin" }
      ];
      if (this.userisAuthenticated) {
        menuItems = [
          { icon: "contact_phone", title: "Contacts", link: "/ContactList" },
          // {
          //   icon: "contact_phone",
          //   title: "Main Offices",
          //   link: "/ContactList"
          // },
          { icon: "hotel", title: "Hotels", link: "/HotelList" }
        ];
      }
      return menuItems;
    },
    userisAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    }
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    }
  }
};
</script>
